import * as CryptoJS from 'crypto-js';
import { SecurityHelper } from './securityHelper';


export class WebStorage {

  static SessionStorage = class {

    static encryptData: boolean = false;

    static SetItem(key: string, value: string) {

      if (this.encryptData) {
        // Encrypt
        value = CryptoJS.AES.encrypt(value, SecurityHelper.WebStorage.GetItem(SecurityHelper.WebStorage.Keys.KY_WEB)).toString();
      }

      sessionStorage.setItem(key, value);
    }

    static GetItem(key: string): string {

      var value = sessionStorage.getItem(key)!;

      if (value && this.encryptData) {
        // Decrypt
        var bytes = CryptoJS.AES.decrypt(value, SecurityHelper.WebStorage.GetItem(SecurityHelper.WebStorage.Keys.KY_WEB));
        value = bytes.toString(CryptoJS.enc.Utf8);
      }

      return value;
    }


    static SetQueryParams(value: string) {

      this.SetItem('queryParams', value);
    }

    static GetQueryParams(): string {

      return this.GetItem('queryParams');
    }

    static ClearQueryParams() {

      sessionStorage.removeItem('queryParams');
    }

  }

}
